import styled from "styled-components"; 

export const PageFromPage = styled.h3`
  display: inline-block; 
  margin-top: 0;
  color: #C1C1C1;
  font-size: 1.2rem;

  div {
    border: 1px solid #C1C1C1;
    border-radius: 5px;
    text-align: center;
    padding: .2rem .8rem;
    display: inline-block;
  }

  span {
    margin: 0 .5rem;
  }
`;